module.exports = __webpack_public_path__ + "static/media/title-booth.a5787e94.svg";